import o from "./index656.js";
import { paginationEmits as m, paginationProps as s } from "./index656.js";
import { withInstall as t } from "./index604.js";
const n = t(o);
export {
  n as ElPagination,
  n as default,
  m as paginationEmits,
  s as paginationProps
};
